import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeliverySlotsService {

  
  url = environment.serverAPI4 + "/api/days"; 
  
  constructor(private http: HttpClient) { }


  getAllDeliverySlotsDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

}
